import { createContext } from 'react';

// Scoped to offer generation from Start or My deals; classic imports keep their behavior.
export const GenerateSaleExportContext = createContext(false);

export const GenerationSourceCreatedContext = createContext<
  ((dataSourceId: string) => void) | undefined
>(undefined);
